<template>
  <div class="milestone-container">
    <div :class="{ 'milestone-inner': true, 'whiteMilestone': image || file }">
      <div class="milestone-title">
        <img :src="require('@/assets/icons/flag-blue.svg')" />
        <p>{{ $t("general.milestone.title") }}!</p>
      </div>
      <p class="milestone-date">{{ date | moment("D MMMM YYYY") }}</p>
      <img class="festoon" :src="require('@/assets/images/festoon.svg')" />

      <img
        class="icon"
        :src="require('@/assets/icons/' + milestone.icon)"
        width="50"
      />
<!-- If a translation is provided (the overridden description) it will be used here-->
      <p class="yay">{{ descriptionOverride || milestone.description }}</p> 
    </div>

    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>
    <i class="snowflake"></i>

    <div class="image" v-if="image || file">
      <div class="overlay"></div>
      <img
        v-if="!file && image"
        :src="image.blobUri"
      />
      <img v-else id="img-preview" :alt="$t('general.post.upload-alt')" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Milestone",
  props: {
    milestone: { required: true },
    date: { required: false },
    image: { required: false, default: null },
    file: { required: false, default: null },
    // Translated description passed in from Post.vue when translate is active
    descriptionOverride: { required: false, default: null }
  }
};
</script>

<style lang="scss" scoped>
.milestone-container {
  width: 100%;
  background-color: #d9f0ea;
  position: relative;
  overflow: hidden;

  .whiteMilestone * {
    color: white;
  }

  .milestone-inner {
    padding: 20px 10px 28px;
    z-index: 2;
    position: relative;
  }

  .image {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    .holder {
      width: 100%;
      background: #d9f0ea;
    }

    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.4;
      z-index: 1;
    }

    img {
      height: 100%;
      object-fit: contain;
      border-radius: 0;
    }
  }
}

.milestone-title {
  display: flex;
  flex-direction: row;
  justify-content: center;

  img {
    float: left;
    width: 30px;
    margin: 0;
  }

  p {
    font-size: 24px;
  }
}
.milestone-date {
  text-align: center;
}

p {
  margin: 0;
}

.festoon {
  max-width: 210px;
  position: relative;
  top: -10px;
  margin: 0 auto;
  display: block;
}

.icon {
  max-width: 110px;
  display: block;
}

.yay {
  color: #e05484;
  max-width: 230px;
  margin: 0 auto;
  text-align: center;
}

@keyframes snowflakes-fall {
  0% {
    top: -10%;
  }
  100% {
    top: 100%;
  }
}
@keyframes snowflakes-shake {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(10px);
  }
}

.snowflake {
  position: absolute;

  text-decoration: none;
  font-style: normal;

  background-color: #e05484;
  opacity: 1;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.25);

  height: 10px;
  width: 10px;
  border-radius: 50%;

  top: -10%;
  z-index: 100;

  user-select: none;
  cursor: default;

  animation-name: snowflakes-fall, snowflakes-shake;
  animation-duration: 10s, 3s;
  animation-timing-function: linear, ease-in-out;
  animation-iteration-count: infinite, infinite;
  animation-play-state: running, running;
}
.snowflake:nth-of-type(0) {
  left: 1%;
  animation-delay: 0s, 0s;
  background-color: #e05484;
}
.snowflake:nth-of-type(1) {
  left: 10%;
  animation-delay: 1s, 1s;
  background-color: #e77f84;
}
.snowflake:nth-of-type(2) {
  left: 20%;
  animation-delay: 6s, 0.5s;
  background-color: #e77f84;
}
.snowflake:nth-of-type(3) {
  left: 30%;
  animation-delay: 4s, 2s;
  background-color: #00a9b3;
}
.snowflake:nth-of-type(4) {
  left: 40%;
  animation-delay: 2s, 2s;
  background-color: #e05484;
}
.snowflake:nth-of-type(5) {
  left: 50%;
  animation-delay: 8s, 3s;
  background-color: #e05484;
}
.snowflake:nth-of-type(6) {
  left: 60%;
  animation-delay: 6s, 2s;
  background-color: #e77f84;
}
.snowflake:nth-of-type(7) {
  left: 70%;
  animation-delay: 2.5s, 1s;
  background-color: #00a9b3;
}
.snowflake:nth-of-type(8) {
  left: 80%;
  animation-delay: 1s, 0s;
  background-color: #e05484;
}
.snowflake:nth-of-type(9) {
  left: 90%;
  animation-delay: 3s, 1.5s;
  background-color: #e77f84;
}
.snowflake:nth-of-type(10) {
  left: 25%;
  animation-delay: 2s, 0s;
  background-color: #00a9b3;
}
.snowflake:nth-of-type(11) {
  left: 65%;
  animation-delay: 4s, 2.5s;
  background-color: #e05484;
}
.snowflake:nth-of-type(12) {
  left: 5%;
  animation-delay: 5s, 2.5s;
  background-color: #e77f84;
}
.snowflake:nth-of-type(13) {
  left: 85%;
  animation-delay: 5.5s, 0s;
  background-color: #00a9b3;
}
</style>
